import { useEffect, useState } from "react";
import ProcessListCard from "../../../../components/Admin/Processes/ETL-Process-List/ProcessListFilters/ProcessListCard";
import ProcessListTable from "../../../../components/Admin/Processes/ETL-Process-List/ProcessListTable/ProcessListTable";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import store from "../../../../store";
import { ETLProcessListEndPointLogic } from "../../../../logic/Admin/ETL Process List/ETLProcessListEndPointLogic";
import SimpleBackdrop from "../../../../components/BackDrop/BackDrop";
import { useSelector } from "react-redux";
import Page404 from "../../../../components/Page404/Page403";
import { useDispatch } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

export default function ETLProcessListScreen(userToken: any) {
  const oauthTokenHeader = userToken?.userToken;
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [status, setStatus] = useState(null);
  const [reload, setReload] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [searchStatus, setSearchStatus] = useState("");
  const response = useSelector(selectUserData);
  const [processes, setProcesses] = useState([]) as any;
  const hasViewProcessListPermission = CheckPermissions(
    response?.data?.products?.admin,
    "processes",
    "view_processes_list"
  );
  const dispatch = useDispatch();
  const tableHeadings = {
    // "edit":"Edit",
    id: "ID",
    name: "Process Name",
    // "process_command": "Process Command",
    last_run: "Last Run",
    status: "Status",
    run_process: "Run Process",
  };

  useEffect(() => {
    const fetchETLProcessList = async () => {
      store.dispatch(setIsLoading(true));
      setIsLoad(true);
      try {
        await Promise.all([
          ETLProcessListEndPointLogic.getETLProcessListDuplicate(oauthTokenHeader, dispatch),
          ETLProcessListEndPointLogic.getProcessList(oauthTokenHeader, setProcesses, dispatch)
        ]);
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      } finally {
        store.dispatch(setIsLoading(false));
        setIsLoad(false);
        setReload(false);
      }
    };

    if (oauthTokenHeader) {
      fetchETLProcessList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, reload]);

  return (
    <>
      {hasViewProcessListPermission ? (
        <>
          <ProcessListCard
            setSelectedProcess={setSelectedProcess}
            selectedProcess={selectedProcess}
            setStatus={setStatus}
            status={status}
            oauthTokenHeader={oauthTokenHeader}
            setReload={setReload}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            page={page}
            setPage={setPage}
            setSearchStatus={setSearchStatus}
            searchStatus={searchStatus}
            processes={processes}
          />
          {isLoad ? (
            <SimpleBackdrop />
          ) : (
            <ProcessListTable
              tableHeadings={tableHeadings}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              selectedProcess={selectedProcess}
              status={status}
              oauthTokenHeader={oauthTokenHeader}
              setReload={setReload}
              setIsLoad={setIsLoad}
              page={page}
              setPage={setPage}
            />
          )}
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
}
